<template>
  <div style="width: 100%;">
    <div class="d-flex list-view-table-row list-view-header-row">
      <div v-on:click="setSortBy('type')" class="justify-center" data-cy="nodeListView-sortBy-type">
        {{ $t('routes.node.nodesAndPods') }}
        <span v-show="sortBy === 'type'">
          <v-icon size="small" v-show="!sortDesc">mdi-sort-ascending</v-icon>
          <v-icon size="small" v-show="sortDesc">mdi-sort-descending</v-icon>
        </span>
      </div>
      <div v-on:click="setSortBy('name')" data-cy="nodeListView-sortBy-name">
        {{ $t('routes.node.name') }}
        <span v-show="sortBy === 'name'">
          <v-icon size="small" v-show="!sortDesc">mdi-sort-ascending</v-icon>
          <v-icon size="small" v-show="sortDesc">mdi-sort-descending</v-icon>
        </span>
      </div>
      <div v-on:click="setSortBy('size')" data-cy="nodeListView-sortBy-size">
        {{ $t('routes.node.size') }}
        <span v-show="sortBy === 'size'">
          <v-icon size="small" v-show="!sortDesc">mdi-sort-ascending</v-icon>
          <v-icon size="small" v-show="sortDesc">mdi-sort-descending</v-icon>
        </span>
      </div>
      <div v-on:click="setSortBy('date')" data-cy="nodeListView-sortBy-dateUploader">
        {{ $t('routes.node.deletedAt') }}
        <span v-show="sortBy === 'date'">
          <v-icon size="small" v-show="!sortDesc">mdi-sort-ascending</v-icon>
          <v-icon size="small" v-show="sortDesc">mdi-sort-descending</v-icon>
        </span>
      </div>
      <div v-on:click="setSortBy('note')" data-cy="nodeListView-sortBy-note">
        {{ $t('routes.node.note') }}
        <span v-show="sortBy === 'note'">
          <v-icon size="small" v-show="!sortDesc">mdi-sort-ascending</v-icon>
          <v-icon size="small" v-show="sortDesc">mdi-sort-descending</v-icon>
        </span>
      </div>
    </div>


    <div v-for="item in paginatedItems" :key="item.id + item.parentid" role="list">
      <ListPodItem
        v-if="item.nodeid"
        :item="item"
        :asSearchResult=false
        :isDeleted=true
        :showPreviews="showPreviews"
        @toggleItemSelection="toggleItemSelectionEvent"
        @showContextMenu="showContextMenu"
        :style="getListItemStyle(item)"
        class="list-view-item list-view-table-row listitem-with-checkbox"
      />

      <ListNodeItem
        v-else
        :item="item"
        :asSearchResult=false
        :disablePodRequests=true
        :isDeleted=true
        @toggleItemSelection="toggleItemSelectionEvent"
        @showContextMenu="showContextMenu"
        :style="getListItemStyle(item)"
        class="list-view-item list-view-table-row listitem-with-checkbox"
      />
    </div>

    <div class="d-flex justify-center my-4" v-if="!noMoreItemsToLoad">
      <v-btn color="primary" @click="loadNextPage" variant="flat">
        {{ $t('routes.recycleBin.loadNextFiles', Math.min(pageSize, totalItems - paginatedItems.length)) }}
      </v-btn>

      <v-btn color="primary" class="ml-4" @click="loadAllItems" variant="flat">
        {{ $t('routes.recycleBin.showAllFiles', totalItems) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { useRecycleBinStore } from '@/stores/RecycleBinStore.js'
import ListNodeItem from '../../nodes2/components/nodeListView/ListNodeItem.vue';
import ListPodItem from '../../nodes2/components/nodeListView/ListPodItem.vue';

export default {
  emits: ["showContextMenu"],
  name: 'RecycleBinListView',
  components: {
    ListNodeItem,
    ListPodItem,
  },
  props: {
    items:{
      type: Array,
      required: true,
    },
    selectedItemsCount: {
      type: Number,
      required: true,
    },
    isShowingConfirmationDialog: {
      type: Boolean,
      default: false,
    },
    confirmationDialogErrorMessage: {
      type: String,
      default: '',
    },
    deletionInProgress: {
      type: Boolean,
      default: false,
    },
    showPreviews: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      sortBy: '',
      sortDesc: false,

      anchorItemSelected: null,

      pageSize: 20,
      currentPage: 1,
    };
  },
  methods: {
    showContextMenu(event) {
      this.$emit('showContextMenu', event);
    },
    setSortBy(sortByColumnName) {
      if (sortByColumnName === null) {
        this.sortBy = '';
        this.sortDesc = false;
        return;
      }

      if (this.sortBy == sortByColumnName) {
        this.sortDesc = !this.sortDesc;
        if (!this.sortDesc) {
          this.sortBy = '';
        }
      } else {
        this.sortBy = sortByColumnName;
        this.sortDesc = false;
      }
    },
    toggleItemSelectionEvent(eventData) {
      // this.$emit('toggleItemSelection', event);

      const indexOfItem = this.getSortedItems.indexOf(eventData.item);
      const indexOfAnchor = this.getSortedItems.findIndex((item) => item.id === this.anchorItemSelected?.id);

      if (indexOfAnchor < 0) {
        this.anchorItemSelected = null;
      }

      if (eventData.holdingShift) {
        this.deselectAllItems();

        if (this.anchorItemSelected !== null && this.anchorItemSelected.id !== eventData.item.id) {
          const minIndex = Math.min(indexOfAnchor, indexOfItem);
          const maxIndex = Math.max(indexOfAnchor, indexOfItem);

          for (let i = minIndex; i <= maxIndex; i++) {
            this.toggleItemSelection(this.getSortedItems[i]);
          }

          return;
        }
      }

      this.toggleItemSelection(eventData.item);
      this.anchorItemSelected = eventData.item;
    },
    toggleItemSelection(item) {
      const recycleBinStore = useRecycleBinStore();
      recycleBinStore.togglePodSelection(item.id);
    },
    deselectAllItems() {
      const recycleBinStore = useRecycleBinStore();
      recycleBinStore.deselectAllPods();
    },
    loadNextPage() {
      this.currentPage++;
    },
    loadAllItems() {
      this.currentPage = Math.ceil(this.totalItems / this.pageSize);
    },
  },
  computed: {
    getSortedItems() {
      if (!this.sortBy) return this.items;

      const itemsCopy = [...this.items];

      switch (this.sortBy) {
        case 'type': itemsCopy.sort(sortByType); break;
        case 'name': itemsCopy.sort(sortByName); break;
        case 'size': itemsCopy.sort(sortBySize); break;
        case 'date': itemsCopy.sort(sortByDate); break;
        case 'note': itemsCopy.sort(sortByNote); break;
        default: break;
      }

      if (this.sortDesc) {
        return itemsCopy.reverse();
      }
      return itemsCopy;

      function sortByType (a, b) {
        if (a.nodeid && b.nodeid) return sortByName(a, b);
        if (a.nodeid && !b.nodeid) return 1;
        if (!a.nodeid && b.nodeid) return -1;
        if (!a.nodeid && !b.nodeid) return a.type - b.type;
      }
      function sortByName (a, b) {
        return a.name.localeCompare(b.name);
      }
      function sortBySize(a, b) {
        let sizeA = a.size || 0;
        let sizeB = b.size || 0;

        return sizeA - sizeB;
      }

      function sortByDate (a, b) {
        let dateA = new Date(a.deletedat);
        let dateB = new Date(b.deletedat);

        if (dateA < dateB) return 1;
        if (dateA > dateB) return -1;
        return 0;
      }
      function sortByNote (a, b) {
        if (a.note && b.note) return a.note.localeCompare(b.note);
        if (a.note && !b.note) return 1;
        if (!a.note && b.note) return -1;
        // if (!a.note && !b.note) return 0;
        return 0;
      }
    },
    totalItems() {
      return this.items.length;
    },
    paginatedItems() {
      const startIndex = 0; // Always start from the beginning for "Load more"
      const endIndex = this.currentPage * this.pageSize;
      return this.getSortedItems.slice(startIndex, endIndex);
    },
    noMoreItemsToLoad() {
      return this.paginatedItems.length >= this.totalItems;
    },

    getListItemStyle() {
      return (item) => {
        const style = {
          'min-height': '104px',
        };

        if (item.id === this.anchorItemSelected?.id) {
          style['border'] = '1px dashed #999999';
        }

        return style;
      }
    }
  }
};
</script>

<style>

/* list-view-item classes are defined in common.css */
/* They are used in other places... (Like the user's list.) */




.list-view-header-row {font-size: 14px; font-weight: 600; cursor: pointer;}

/* .list-view-table-row { border-bottom: 1px solid #1f1f1f; } */
.list-view-table-row > div {
  display: flex;

  align-items: center;
  padding: 0px 4px;
  font-size: .875rem;
  word-break: normal;
}




/* Normal screens */
.list-view-table-row > div:nth-child(1) {/*flex: 1;*/ width: 42px; justify-content: center;}    /* select box */
.list-view-table-row > div:nth-child(2) {/*flex: 3;*/ width: 148px; }   /* thumbnail */
.list-view-table-row > div:nth-child(3) {flex: 7; min-width: 0;}   /* name */
.list-view-table-row > div:nth-child(4) {
  flex: 2; min-width: 85px; flex-direction: column; justify-content: center;}   /* size */
.list-view-table-row > div:nth-child(5) {flex: 3; min-width: 100px; }   /* uploader */
.list-view-table-row > div:nth-child(6) {flex: 4; min-width: 120px; }   /* notes */
.list-view-table-row > div:nth-child(7) {/*flex: 1;*/ width: 36px; justify-content: right;}    /* actions */


/* Small screens */
@media only screen and (max-width: 960px) {
  .list-view-table-row > div:nth-child(1) {flex: 2; }   /* select box */
  .list-view-table-row > div:nth-child(2) {flex: 6; }   /* thumbnail */
  .list-view-table-row > div:nth-child(3) {flex: 10;}   /* name */
  .list-view-table-row > div:nth-child(4) { display: none; }   /* size */
  .list-view-table-row > div:nth-child(5) { display: none; }   /* uploader */
  .list-view-table-row > div:nth-child(6) { display: none; }   /* notes */
  .list-view-table-row > div:nth-child(7) {flex: 2; }    /* actions */
}
</style>
